<script>
    import {album} from "./photo-store";
    import PhotoDetail from "./PhotoDetail.svelte";
    import Spinner from "../../components/ui/Spinner.svelte";

    let selected;
</script>
<!--------------------------------------------------------------------------------------------------------------------->

<div class="photos">
    {#each $album as photo (photo.id)}
        <img src={photo.src} alt={photo.alt} title={photo.alt} on:click={() => {selected = photo}} />
    {:else}
        <Spinner />
    {/each}
</div>

{#if selected}
    <PhotoDetail on:cancel={() => {selected = null}} photo={selected}/>
{/if}
<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .photos {
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    img {
        width: 315px;
        height: 210px;
        padding: 0;
        margin: 5px 5px 6px;
        border-radius: 4px;
        transition: all .6s ease;
    }
    img:hover {
        transform: scale(1.03);
    }
    img:not(:hover) {
        filter: grayscale(100%);
    }

    /*==================================     MEDIA     ======================================*/

    /*@media screen and (max-width: 300px) {
        img {
            width: 200px;
            height: 134px;
        }
    }*/

    @media screen and (max-width: 500px) {
        .photos {
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: center;
            row-gap: 2.5rem;
        }
        img {
            width: 100%;
            height: auto;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        }
        img:not(:hover) {
            filter: unset;
        }
        img:hover {
            transform: unset;
        }
    }
</style>
